import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  songIdeasList: {
    position: 'relative',
    display: 'grid',
    gridGap: '12px',
    gridTemplateColumns: 'repeat(5, minmax(auto,1fr))',

    '@media screen and (min-width: 1441px)': {
      gridGap: '16px',
      gridTemplateColumns: 'repeat(6, minmax(auto,1fr))',
    },
  },

  cardMiddle: {
    height: '100%',
    width: '100%',
    position: 'relative',

    '& > *:not(.viboImage)': {
      position: 'absolute',
      zIndex: 1,
    },

    '& .songsCount, & > .stopPropagationWrapper :is(.viboToggleDropdown, .viboButton)': {
      backgroundColor: 'var(--overlay-default)',
      borderRadius: '4px',
      padding: '4px',
    },

    '& .songsCount': {
      display: 'flex',
      alignItems: 'center',
      gap: '2px',
      left: '6px',
      top: '6px',
      fontSize: '11px',

      '@media screen and (min-width: 1441px)': {
        gap: '4px',
        left: '8px',
        top: '8px',
        fontSize: '14px',
      },
    },

    '& .customLabel': {
      bottom: '6px',
      left: '6px',

      '@media screen and (min-width: 1441px)': {
        bottom: '8px',
        left: '8px',
      },
    },

    '& .viboToggleDropdown.rc-dropdown-open': {
      color: 'var(--buttonActiveToWhite)',
      backgroundColor: 'var(--primaryLightToBalticSea)!important',
    },

    '& .stopPropagationWrapper': {
      lineHeight: 0,
      top: '6px',
      right: '6px',

      '@media screen and (min-width: 1441px)': {
        top: '8px',
        right: '8px',
      },
    },

    '& .sourceIcon': {
      backgroundColor: 'var(--background-paper)',
      borderRadius: '50%',
      bottom: '6px',
      right: '6px',

      '@media screen and (min-width: 1441px)': {
        bottom: '8px',
        right: '8px',
      },
    },

    '& .viboImage': {
      aspectRatio: '1/1',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,

      '& img': {
        objectFit: 'cover',
      },
    },

    '& .gradient .viboIcon': {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%,-50%)',
      color: 'var(--background-paper)',
      fontSize: '48px',
    },
  },

  cardAnimate: {
    border: `2px solid var(--primary-main)!important`,
    boxShadow: 'var(--shadows-0)',

    '&:hover': {
      boxShadow: 'var(--shadows-0)',
    },
  },

  playlistCard: {
    cursor: 'pointer',
    display: 'grid',
    gridTemplateRows: '1fr 28px',
    position: 'relative',
    userSelect: 'none',
    backgroundColor: 'var(--background-paper)',

    '&.loading': {
      ...mixins.noClickableFilter,
    },

    '& .songsCount': {
      gap: '4px',

      '& .viboIconSVG': {
        width: '14px',
        height: '14px',

        '@media screen and (min-width: 1441px)': {
          width: '16px',
          height: '16px',
        },
      },
    },

    '& .ellipsis': {
      color: 'var(--primary-main)',

      '& svg': {
        width: '14px',
        height: '14px',

        '@media screen and (min-width: 1441px)': {
          width: '16px',
          height: '16px',
        },
      },

      '&:hover': {
        '& path': {
          fill: 'var(--action-hover)',
        },
      },
    },

    '& .title': {
      ...mixins.longText,
      padding: '6px',
      fontSize: '11px',
      lineHeight: '14px',
      color: 'var(--text-primary)',

      '@media screen and (min-width: 1441px)': {
        padding: '8px',
        fontSize: '14px',
        lineHeight: '20px',
      },
    },

    '& .cardMiddle > .stopPropagationWrapper :is(.viboToggleDropdown:not(.rc-dropdown-open), .viboButton)': {
      display: 'none',
    },

    '&:hover': {
      backgroundColor: 'var(--selection-hover)',

      '& .cardMiddle > .stopPropagationWrapper :is(.viboToggleDropdown, .viboButton)': {
        display: 'flex',
      },
    },

    '@media screen and (min-width: 1441px)': {
      gridTemplateRows: '1fr 36px',
    },
  },
}));

export default useStyles;
